import { useLocation } from "react-router"

export default function useSearchParams() {
  const location = useLocation()

  const queryParams = new URLSearchParams(location.search)

  const get = (value: string) => queryParams.get(value)

  return { get }
}
